import type { ChartData } from '../catalog/types';
import { getSliceGradientFill } from '../theme/chartGradients';

export type DonutPieDatum = Readonly<{
  id: number;
  value: number;
  label: string;
  color: string;
}>;

export function buildDonutPieData(
  data: ChartData,
  chartId: string
): DonutPieDatum[] {
  return data.values.map((value, index) => ({
    id: index,
    value,
    label: data.labels[index] ?? String(index),
    color: getSliceGradientFill(chartId, index),
  }));
}
